import type { ProjectRecord } from "@/lib/api";
import type { WaitingGroup } from "@/lib/overview";
import { Box, Text } from "@okshaun/components";
import { RailSection } from "./rail-section";

interface WaitingRailProps {
  groups: WaitingGroup[];
  total: number;
  scoped: ProjectRecord | null;
}

export function WaitingRail({ groups, total, scoped }: WaitingRailProps) {
  return (
    <RailSection title="Waiting on" scope={scoped?.name} meta={`${total} · not your move`}>
      {groups.length === 0 && (
        <Text textStyle="mono.sm" color="text.subtlest" p="8">
          Nothing is waiting on anyone.
        </Text>
      )}
      {groups.map(({ person, tasks }) => (
        <Box key={person} display="flex" flexDir="column" gap="4" px="12" py="8">
          <Box display="flex" gap="8" alignItems="baseline">
            <Text fontSize="13" fontWeight="semibold" color="text.bold">
              {person}
            </Text>
            <Text textStyle="mono.xs" color="text.subtlest">
              {tasks.length}
            </Text>
          </Box>
          {tasks.map((t) => (
            <Box key={t.id} display="flex" gap="8" alignItems="baseline">
              <Text textStyle="mono.xs" color="text.warning" aria-hidden="true">
                ◔
              </Text>
              <Text fontSize="13" lineHeight="default" color="text">
                {t.text}
              </Text>
            </Box>
          ))}
        </Box>
      ))}
    </RailSection>
  );
}
